import { JobStatus } from '../../features/home/models/job-status';

export function detectConversionMode(fileName: string): string {
  const extension = fileName.split('.').pop()?.toLowerCase();
  if (extension === 'zip') {
    return 'Gerber';
  } else if (extension === 'mdl') {
    return 'Lectra';
  } else {
    return 'Unknown';
  }
}

export function mapStatus(status: string): JobStatus {
  switch (status) {
    case 'Done':
      return JobStatus.Complete;
    case 'Error':
      return JobStatus.Error;
    case 'Processing':
      return JobStatus.Processing;
    case 'Waiting':
      return JobStatus.Wait;
    case 'Unknown':
      return JobStatus.Unknown;
    default:
      return JobStatus.Unknown;
  }
}
